import { useQuery } from "@apollo/client/react";
import { WAREHOUSE_LOCATIONS_COLLECTION_INVENTORY_TRANSACTION } from "../../../../../constants/graphql/queries";

export const ITEMS_PER_PAGE = 50;

export default function useWarehouseLocations(options = {}) {
  const { variables, ...otherOptions } = options;
  const hasSearch = variables?.search && variables.search.trim().length > 0;
  
  return useQuery(WAREHOUSE_LOCATIONS_COLLECTION_INVENTORY_TRANSACTION, {
    variables,
    // Use cache-and-network for searches to ensure fresh results
    // Use cache-first for initial loads to improve performance
    fetchPolicy: hasSearch ? 'cache-and-network' : 'cache-first',
    // Always include error details
    errorPolicy: 'all',
    // Prevent unnecessary re-fetches on component re-renders
    notifyOnNetworkStatusChange: true,
    ...otherOptions
  });
}
